import { createReducer, on } from '@ngrx/store';
import { User } from 'src/typings';

import {
  changeWindowWith,
  loginUser,
  logoutUser,
  setLoading,
  updateDeviceInfo,
  updateUser,
  updateFiscalSession
} from '../actions/user.actions';
import { DeviceTypeEnum } from 'src/enums';
import { DeviceInfo } from 'ngx-device-detector';

export const initialState: {
  info: User | undefined | null;
  deviceType: DeviceTypeEnum;
  deviceInfo: DeviceInfo | null;
  loading: boolean;
} = {
  info: undefined,
  deviceType: DeviceTypeEnum.DESKTOP,
  deviceInfo: null,
  loading: false
};

export const userReducer = createReducer(
  initialState,
  on(loginUser, (state, { payload }) => {
    return {
      ...payload,
      deviceType: state.deviceType,
      deviceInfo: null,
      loading: false
    };
  }),
  on(updateDeviceInfo, (state, { deviceInfo }) => ({ ...state, deviceInfo })),
  on(logoutUser, () => initialState),
  on(changeWindowWith, (state, { payload }) => {
    return { ...state, deviceType: payload.device_type };
  }),
  on(updateUser, (state, { payload }) => {
    return { ...state, info: payload };
  }),
  on(updateFiscalSession, (state, { userId, fiscalId, isSessionOpen }) => {
    if (state.info?.id !== userId || state.info?.fiscal?.id !== fiscalId ||
        state.info.fiscal.isSessionOpen === isSessionOpen) return state;
    return {
      ...state,
      info: { ...state.info, fiscal: { ...state.info.fiscal, isSessionOpen } }
    };
  }),
  on(setLoading, (state, { payload }) => {
    return { ...state, loading: payload };
  })
);
